import React from 'react';
import PropTypes from 'prop-types';

const Heading = ({ element: elementProp, children, className }) => {
  const Element = elementProp;

  return <Element className={className}>{children}</Element>;
};

Heading.defaultProps = {
  element: 'h2',
  className: null,
};

Heading.propTypes = {
  children: PropTypes.node.isRequired,
  element: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  className: PropTypes.string,
};

export default Heading;
